module.exports = __webpack_public_path__ + "img/icon_search.7c7d20bd.svg";